import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import dotenv from 'dotenv';
import { Buffer } from 'buffer';

export const TestPage = () => {
  const [username, setUserName] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [canAccess, setAccess] = React.useState(false);
  const [customer, setCustomer] = React.useState('reeltime');
  const [url, setUrl] = React.useState('https://reeltime.no');

  if (process.env.NODE_ENV == 'development' && !canAccess) {
    setAccess(true);
  }

  //const auth = "tester";
  //https://qr.reeltime.no

  async function generate(e: any) {
    e.preventDefault();

    if (canAccess && username && password) {
      const auth = Buffer.from(username + ':' + password).toString('base64');

      const request = await fetch('/generate-qr', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: 'Basic ' + auth,
        },
        body: JSON.stringify({
          customer: customer,
          url: url,
        }),
      });
      const response = await request.json();
      console.log(response);
    }
  }

  return (
    <>
      {' '}
      {!canAccess ? null : (
        <form onSubmit={generate}>
          <table>
            <tbody>
              <tr>
                <td>Username</td>
                <td>
                  <input
                    name="username"
                    type="textbox"
                    value={username}
                    onChange={(e) => setUserName(e.target.value)}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>Passord</td>
                <td>
                  <input
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>Kunde</td>
                <td>
                  <input
                    name="customer"
                    type="textbox"
                    value={customer}
                    onChange={(e) => setCustomer(e.target.value)}
                  ></input>
                </td>
              </tr>
              <tr>
                <td>URL</td>
                <td>
                  <input
                    name="url"
                    type="textbox"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                  ></input>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <button type="submit">Send</button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      )}
    </>
  );
};
